import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWebAssetOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M39.023 41.161L32.192 34.3305H6.0845C5.08717 34.3305 4.23517 33.9773 3.5285 33.271C2.82217 32.5643 2.469 31.7123 2.469 30.715V7.946C2.469 6.94867 2.82217 6.09667 3.5285 5.39C4.23517 4.68367 5.08717 4.3305 6.0845 4.3305H6.469V8.6075L0 2.138L2.1385 0L41.1615 39.023L39.023 41.161ZM6.0845 31.3305H29.192L9.192 11.3305H5.469V30.715C5.469 30.8947 5.52667 31.0422 5.642 31.1575C5.75733 31.2728 5.90483 31.3305 6.0845 31.3305ZM40.096 32.296L37.469 29.669V11.3305H19.1305L12.1305 4.3305H36.8535C37.8508 4.3305 38.7028 4.68367 39.4095 5.39C40.1158 6.09667 40.469 6.94867 40.469 7.946V30.715C40.469 30.997 40.4388 31.274 40.3785 31.546C40.3182 31.8177 40.224 32.0677 40.096 32.296Z",
		fill: "currentColor",
		fillOpacity: .25
	})
});
export default SvgWebAssetOff;
